import { Component, OnInit } from '@angular/core';
import {DataService} from '../data.service';
import { CountryService } from '../country.service';
import {Router, ActivatedRoute} from '@angular/router';
import {IMyDpOptions, IMyDateModel, IMyDate} from 'mydatepicker';
import {NgForm} from '@angular/forms';



declare var $: any;
declare var body: any;
declare var google: any;
declare var Nanobar: any;
declare var toastr: any;

@Component({
  selector: 'app-add-story',
  templateUrl: './add-story.component.html',
  styleUrls: ['./add-story.component.css']
})
export class AddStoryComponent implements OnInit {
  description: any;
  title: any;
  coverImage: any;
  date = new Date();
  data = 'appendix';
  error_count = 0;
  addstoryData: any;
  imageUploadData: any;
  previewHtml: any;
  addDisable = false;
  author: any;
  businessListig: any;
  dispensary_id: any = '-1';
  dispensary_name: any;
  constructor(private dataService: DataService, private cs: CountryService, private router: Router) {
    this.dataService.pageName = 'add story';
    if (window.localStorage.getItem('isauthenticated') !== 'true') {
      window.location.href = '/';
    }
  }

// businessList(){
//   this.dataService.getBusinessList(window.localStorage.getItem('token')).subscribe(
//     (data) => {
//       this.businessListig = data;
//       console.log('list', this.businessList);
//     },
//     (error) => {
//     }
//   );
// }


  
  addStory() {
    $('.c-label label').css('color', '#3d3e3d');
    $('.uploadTextStory').css('color', '#3d3e3d');
    $('.c-label input').css('border-color', '#ccc');
    $('.imgbackcover').css('border-color', '#ccc');
    this.error_count = 0;
    if (this.author === '' || this.author === undefined) {
      $('#author label').css('color', '#a10a0d');
      $('#author input').css('border-color', '#a10a0d');
      this.error_count ++;
    }
    if (this.title === '' || this.title === undefined) {
      $('#title label').css('color', '#a10a0d');
      $('#title input').css('border-color', '#a10a0d');
      this.error_count ++;
    }
    if (this.description === '' || this.description === undefined) {
      $('#description label').css('color', '#a10a0d');
      $('#description input').css('border-color', '#a10a0d');
      this.error_count ++;
    }
    if (this.coverImage === '' || this.coverImage === undefined || this.coverImage === null) {
      $('.imgbackcover').css('border-color', '#a10a0d');
      $('.uploadTextStory').css('color', '#a10a0d');
      this.error_count ++;
    }
    if (this.error_count > 0) {
      return;
    }
    this.addDisable = true;
    var html = $('#summernote').summernote('code');
    console.log(this.dispensary_id);
      this.dataService.addStory(window.localStorage.getItem('token'), this.title, this.description, this.author, html).subscribe(
        (data) => {
          this.addstoryData = data;
          if( this.addstoryData.success === true ){
            this.uploadStoryImage();
          }
          if( this.addstoryData.success === false ){
            toastr.success('Something went wrong');
            this.addDisable = false;
          }
        },
        (error) => {
        }
      );
  }

  
  uploadStoryImage(){
    this.dataService.addStoryImage(window.localStorage.getItem('token'), this.addstoryData.article_id, this.coverImage).subscribe(
      (data) => {
        this.imageUploadData = data;
        this.addDisable = false;
        if( this.imageUploadData.success === true ) {
          toastr.success('Story upload sucessfuly');
          this.router.navigate(['story']);
        }
        if( this.imageUploadData.success === false ) {
          toastr.success('Something went wrong');
        }
      },
      (error) => {
      }
    );
  }

  clearStoryImage() {
    $('.cropit-image-input-story').val('');
  }
  expotyStory() {
    $('.imgbackcover').css('height', 'auto');
    $('.cropit-image-input-story').val('');
    this.coverImage = $('.image-cropper-story').cropit('export', {
      originalSize: true,
      quality: 1,
      type: 'image/png',
    });
    $('#cropperStoryImgPop').modal('hide');
  }
  previewOpenPop(){
    $('.c-label label').css('color', '#3d3e3d');
    $('.uploadTextStory').css('color', '#3d3e3d');
    $('.c-label input').css('border-color', '#ccc');
    $('.imgbackcover').css('border-color', '#ccc');
    this.error_count = 0;
    if (this.title === '' || this.title === undefined) {
      $('#title label').css('color', '#a10a0d');
      $('#title input').css('border-color', '#a10a0d');
      this.error_count ++;
    }
    if (this.author === '' || this.author === undefined) {
      $('#author label').css('color', '#a10a0d');
      $('#author input').css('border-color', '#a10a0d');
      this.error_count ++;
    }
    if (this.description === '' || this.description === undefined) {
      $('#description label').css('color', '#a10a0d');
      $('#description input').css('border-color', '#a10a0d');
      this.error_count ++;
    }
    if (this.coverImage === '' || this.coverImage === undefined || this.coverImage === null) {
      $('.imgbackcover').css('border-color', '#a10a0d');
      $('.uploadTextStory').css('color', '#a10a0d');
      this.error_count ++;
    }
    if (this.error_count > 0) {
      return;
    }
    this.previewHtml = $('#summernote').summernote('code');
    console.log('this.previewHtml', this.previewHtml);
    document.getElementById( 'policyPreview').innerHTML = this.previewHtml;
    $('#preivewPopup').modal('show');
  }
  callsummerFun() {
    $('#summernote').summernote({
      placeholder: 'Story Description here',
      tabsize: 2,
      height: 300,
      minHeight: 300,
    });
  }
  ngOnInit() {
    this.callsummerFun();
//this.businessList();


    setTimeout(() => {
      $('.image-cropper-story').cropit({
        $preview: $('.cropit-preview-story'),
        $fileInput: $('.cropit-image-input-story'),
        $zoomSlider: $('.cropit-image-zoom-input-story'),
        allowDragNDrop: true,
        minZoom: 'fill',
        initialZoom: 'min',
        maxZoom: 20,
        imageBackground: true,
        imageBackgroundBorderWidth: 30,
        smallImage: 'allow',
      });
    }, 1500);
    $('#cropit-image-input-story').change(function() {
      console.log('in image preview2');
      console.log('', $('.cropit-image-input-story').val());
      if ($('.cropit-image-input-story').val() !== '') {
        $('#cropperStoryImgPop').modal('show');
      }
    });
    $('.select-image-btn-story').click(function() {
      $('#cropit-image-input-story').click();
    });
    $('.header').css('display', 'inline-block');
    $('.footer').css('display', 'inline-block');
    $('#sidebar').css('display', 'block');
    $('.clearSideSelecteion').css('color', '#3d3d3d');
    $('#story').css('color', '#d77229');
  }

}



// WEBPACK FOOTER //
// ./src/app/add-story/add-story.component.ts